import PersonalDataConsentModal from './PersonalDataConsentModal.vue';

export default PersonalDataConsentModal;



// WEBPACK FOOTER //
// ./src/components/personalDataConsentModal/index.ts